export enum EBookCoworkingFormFields {
  CoworkingOfferType = 'coworkingOfferType',
  IsBroker = 'isBroker',
  Name = 'name',
  Phone = 'phone',
  RentDuration = 'rentDuration',
  RentDurationUnit = 'rentDurationUnit',
  RentStartDate = 'rentStartDate',
  WorkplaceCount = 'workplaceCount',
}

export enum EBookCoworkingValidateActionTypes {
  ValidateAll = 'validateAll',
  ValidateByField = 'validateByField',
}
